import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from '@/plugins/vuetify';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueQRCodeComponent from 'vue-qrcode-component';
import MobileSignalRPlugin from '@/plugins/signalR/mobile';
import MainSignalRPlugin from '@/plugins/signalR/main';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueCookies from 'vue-cookies';
import titleMixin from './titleMixin';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import '@/assets/styles/main.scss';
// import { setupApiInterceptors } from '@/plugins/apiClient';


Vue.config.productionTip = false;
Vue.mixin(titleMixin);
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.use(require('vue-moment-jalaali'));
Vue.component('qr-code', VueQRCodeComponent);
Vue.use(MainSignalRPlugin, {
  hubUrl: `${Constants.HUBURL}/notificationHub`,
  router,
  getToken: () => localStorage.getItem('token') || '',
});
Vue.use(MobileSignalRPlugin, {
  hubUrl: `${Constants.HUBURL2}/notificationHub`,
  router,
  getToken: () => localStorage.getItem('token') || '',
});
//Vue.use(require('vue-cookies'))
Vue.use(VueCookies, { expires: '3y' });
Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  toastClassName: 'custom-toast', // ✅ کلاس سفارشی
});
//highcharts
import HighCharts from 'highcharts';
import Maps from 'highcharts/modules/map';
import Exp from 'highcharts/modules/exporting';
import HighchartsVue from 'highcharts-vue';
import Constants from './plugins/constants';

Maps(HighCharts);
Exp(HighCharts);
Vue.use(HighchartsVue, HighCharts);
HighCharts.dateFormats = {
  a: function (ts) {
    return new Vue.moment(ts).format('dddd');
  },
  A: function (ts) {
    return new Vue.moment(ts).format('dddd');
  },
  d: function (ts) {
    return new Vue.moment(ts).format('jDD');
  },
  e: function (ts) {
    return new Vue.moment(ts).format('jD');
  },
  b: function (ts) {
    return new Vue.moment(ts).format('jMMMM');
  },
  B: function (ts) {
    return new Vue.moment(ts).format('jMMMM');
  },
  m: function (ts) {
    return new Vue.moment(ts).format('jMM');
  },
  y: function (ts) {
    return new Vue.moment(ts).format('jYY');
  },
  Y: function (ts) {
    return new Vue.moment(ts).format('jYYYY');
  },
  W: function (ts) {
    return new Vue.moment(ts).format('d');
  },
};
HighCharts.setOptions({
  chart: {
    style: {
      fontFamily: 'a_iranian_sansregular',
      direction: 'rtl',
      textAlign: 'right',
    },
  },
  lang: {
    numericSymbols: ['Th', ' M', 'B', 'T'],
    resetZoom: 'تنظیم مجدد',
  },
  navigation: {
    buttonOptions: {
      verticalAlign: 'bottom',
      align: 'left',
      x: -10,
      y: 20,
    },
  },
});

// setupApiInterceptors(store, router);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
